<script lang="ts" setup>
import { HeartHandshake } from 'lucide-vue-next';

import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import type { ChatEndEvent } from '@sigma/chat-common/ChatEvent.js';
import { defineChatEventProps } from '@sigma/client/chat/defineChatEventProps.js';
import ChatEventWrapper from '@sigma/ui/chat/ChatEventWrapper.vue';
import ChatStatusNotice from '@sigma/ui/chat/ChatStatusNotice.vue';

import chatCss from './chat.module.scss';
import * as l from './ChatEnd.loc.js';

defineProps(defineChatEventProps<ChatEndEvent>());
const t = useTranslate();
</script>

<template>
  <ChatEventWrapper
    :event="event"
    :class="chatCss.container"
  >
    <ChatStatusNotice
      tid="patient-chat-ended"
      :icon="HeartHandshake"
      :headline="t(l.chatEndedHeadline)"
      :caption="t(l.chatEndedCaption)"
      :class="css.ended"
    />
  </ChatEventWrapper>
</template>

<style lang="scss" module="css">
.ended {
  margin-block: $spacing-16;
}
</style>
